const faqButtons = document.querySelectorAll('.faq__button');

const TOGGLED_FAQ_ITEM_CLASS = 'faq__item--opened';

if (faqButtons.length > 0) {
    faqButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            btn.parentElement.classList.toggle(TOGGLED_FAQ_ITEM_CLASS);
        });
    });
}
